import Home from 'components/Home';

export default {
  index: true,
  Component: Home
};
